
import { API_ENDPOINTS } from "../api";
import { getService } from "../servce/ApisService";

interface ProposalResponse {
  proposalType?: string;
  status?: string;
}

interface ServiceResponse {
  [key: string]: any; // Adjust based on your API response
}
const menuItems = [
  {
    name: "Hospital Profiling",
    key: "isHospitalProfiling",
    path: "/vendorDashboard/activateDashbord/HospitalViewProfile",
    to: "/portals/dashboard",
    img: "/images/hospitalCenters.svg",
    activeImg:"/images/hospitalCentersActive.svg",
    condition: (data: any) => data.isHospitalProfiling,
  },
  {
    name: "Company Profiling",
    key: "isCompanyProfiling",
    path: "/vendorDashboard/activateDashbord/companyViewProfile",
    to: "/portals/dashboard",
    img: "/images/hospitalCenters.svg",
    activeImg:"/images/hospitalCenters.svg",
    condition: (data: any) => data.isCompanyProfiling,
  },
  // {
  //   name: "Event Profiling",
  //   key: "isEventProfiling",
  //   path: "/vendorDashboard/activateDashbord/eventViewProfile",
  //   to: "/portals/dashboard",
  //   img: "/images/hospitalCenters.svg",
  //   activeImg:"/images/hospitalCentersActive.svg",
  //   condition: (data: any) => data.isEventProfiling,
  // },
  {
    name: "Events",
    key: "isEmailMarketing",
    path: "/vendorDashboard/activateDashbord/eventListing",
    img: "/images/eventlist.svg",
    activeImg: "/images/eventlistActive.svg",
    condition: (data: any) => data.isEventListing,
  },
  {
    name: "Banner Ads",
    key: "isBannerAds",
    path: "/vendorDashboard/activateDashbord/banner-ads",
    img: "/images/bannerIcon.svg",
    activeImg: "/images/bannerActive.svg",
    condition: (data: any) => data.isBannerAds,
  },
  {
    name: "Email Marketing",
    key: "isEmailMarketing",
    path: "/vendorDashboard/activateDashbord/email-marketing",
    img: "/images/emailMarketings.svg",
    activeImg: "/images/emailMarketingActive.svg",
    condition: (data: any) => data.isEmailMarketing,
  },
 
  {
    name: "Newsletter Ads",
    key: "isNewsLetterAds",
    path: "/vendorDashboard/activateDashbord/newsletter-ads",
    img: "/images/newsletterIcon.svg",
    activeImg: "/images/newsletterActive.svg",
    condition: (data: any) => data.isNewsLetterAds,
  },
  {
    name: "Content Marketing",
    key: "isContentMarketing",
    path: "/vendorDashboard/activateDashbord/contentMarketing",
    img: "/images/contentMarket.svg",
    activeImg: "/images/contentMarketingProfile.svg",
    condition: (data: any) => data.isContentMarketing,
  },
  {
    name: "Print Ad",
    key: "isPrintAd",
    path: "/vendorDashboard/activateDashbord/printAd",
    img: "/images/Print advertising.svg",
    activeImg: "/images/Print advertisingActive.svg",
    condition: (data: any) => data.isPrintAd,
  },
];
export const handleRedirection = async (
  navigate: (path: string) => void,
  vendorId: string
) => {
  try {
    if (!vendorId) {
      console.warn("Vendor ID is missing.");
      return;
    }

    // Call API with vendorId as a query parameter
    const response = await getService(
      `${API_ENDPOINTS.getActivatedServices}?vendorId=${vendorId}`
    );

    console.log(response);
    

    if (!response || !response.data) {
      console.warn("Invalid response received from API.");
      return;
    }



    // Find the first active service from the menu items
    const firstService = menuItems.find((item) => item.condition(response.data));

    if (firstService) {
      navigate(firstService.path);
    } else {
      console.warn("No active services found.");
    }
  } catch (error) {
    console.error("Error handling redirection:", error);
  }
};
